var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_570",
    "data-name": "Group 570",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12722",
    "data-name": "Path 12722",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12723",
    "data-name": "Path 12723",
    d: "M13.038,14.234a2.573,2.573,0,1,1,2.573-2.573,2.576,2.576,0,0,1-2.573,2.573",
    transform: "translate(2.093 1.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12724",
    "data-name": "Path 12724",
    d: "M27.674,13.647A23.536,23.536,0,0,0,19.938,7.13a11.9,11.9,0,0,0-5.156-1.264A11.887,11.887,0,0,0,9.628,7.13,23.547,23.547,0,0,0,1.89,13.647a.769.769,0,0,0,0,.913,24.894,24.894,0,0,0,3.72,3.866c3.046,2.561,6.217,3.914,9.172,3.914s6.127-1.354,9.174-3.914a24.919,24.919,0,0,0,3.719-3.866.769.769,0,0,0,0-.913m-17.221-5.2c.068-.032.138-.065.206-.094.119-.054.235-.1.353-.151.084-.035.168-.068.252-.1s.185-.071.276-.1c.062-.023.124-.043.184-.064.1-.035.2-.065.294-.095.044-.014.089-.026.132-.04q.425-.124.844-.209l.139-.028.139-.024a8.785,8.785,0,0,1,1.51-.133,8.9,8.9,0,0,1,1.4.114l.106.019.15.026.13.025c.278.056.56.126.844.209l.116.035c.1.031.205.065.308.1.061.02.122.041.185.064.091.031.184.066.276.1s.168.065.252.1q.292.119.583.254a5.81,5.81,0,1,1-8.7,0l.023-.01M14.782,20.8c-3.258,0-6.232-1.92-8.153-3.53A24.648,24.648,0,0,1,3.494,14.1a24.281,24.281,0,0,1,4.294-4.069,7.352,7.352,0,1,0,13.99,0A24.286,24.286,0,0,1,26.071,14.1c-1.3,1.578-5.921,6.7-11.29,6.7",
    transform: "translate(0.348 1.173)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewRate);
export default __webpack_public_path__ + "static/media/icon-view_rate.c7224df3bdb40f91507a8de20883da83.svg";
export { ForwardRef as ReactComponent };